import React, { useState, useEffect, useContext } from "react";
import { plantCurveApi, PlantMisApi } from "../../../../../api/Api";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../assets/img/logos/logo 2.png';
import EnergyChartPower from "../../../../../components/charts/energy_reporting/EnergyChartPower";
import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme, Button } from '@mui/material';
import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import TopHeaderBusiness from "../../../../../components/general/TopHeaderBusiness";
import InvoicePage from "../InvoicePage/InvoicePage";



// Utility function to format date as 'YYYY-MM-DD HH:mm'
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD


    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}


export default function PlantMis() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [endDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { spacing, palette, shape: { borderRadius } } = useTheme();

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    // const [itemsPerPage] = useState(10);
    const [itemsPerPage, setItemsPerPage] = useState(12);

    const [chartLabels, setChartLabels] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [gradientFill, setGradientFill] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const credentials = {
        suser: localStorage.getItem("business_LOGIN_ID") || "",
        DT1: endDate,


    };

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await PlantMisApi(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
                setFilteredData(res.data);
            } else {
                setLogData([]);
            }
        } catch (err) {
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchLogData();
    }, [credentials.LOGIN_ID]);


    useEffect(() => {
        let updatedData = logData;
    
        if (searchQuery.trim() !== "") {
            updatedData = logData.filter((item) =>
                Object.values(item)
                    .join(" ")
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
            );
        }
    
        setFilteredData(updatedData); // ← Important
        setCurrentPage(1); // Reset to first page on search
    }, [searchQuery, logData]);
    

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Define keys to exclude (you can also define keys to include instead)
    const excludeKeys = ["LOC_CODE"]; // Replace "key1", "key2" with actual keys you don't want to export

    // Filter logData
    const filteredLogData = logData.map((item) => {
        const filteredItem = {};
        Object.keys(item).forEach((key) => {
            if (!excludeKeys.includes(key)) {
                filteredItem[key] = item[key]; // Include keys not in excludeKeys
            }
        });
        return filteredItem;
    });

    // Get table headers from filteredLogData
    const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

    // Export to Excel
    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filteredLogData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Plant MIS");
        XLSX.writeFile(wb, `Plant MIS To ${endDate.replace(" ", "T")} Plant MIS.xls`);
    };

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();

        // Add Logo (x, y, width, height)
        const imgWidth = 30;  // Adjust width
        const imgHeight = 20; // Adjust height
        const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
        doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

        // Add Title or Text Below the Logo
        const title = `Plant MIS To ${endDate.replace(" ", "T")}`;
        doc.setFontSize(12);  // Adjust font size
        doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

        // Adjust Y position for the table to start below the text
        let startY = 50;  // Push table further down below text

        doc.autoTable({
            head: [tableHeaders],
            body: currentData.map((item) => tableHeaders.map((key) => item[key])),
            startY: startY,  // Start table below the logo and text
            theme: "grid",
        });

        doc.save(`Plant MIS To ${endDate.replace(" ", "T")} Plant MIS`);
    };




    const handleEndDateChange = (value) => {
        setEndDate(value); // Update the EndDate directly
    };

    // Refresh data only when clicking "Show"
    function onRefreshData() {
        if (endDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }

    return (
        <>


            <TopHeaderBusiness />

            <Grid container style={{ padding: "0", margin: "0" }}>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
                        {/* First Card */}
                        <Stack
                            component={Card}
                            p={spacing(1)}
                            sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                        >

                            <div>

                                <div style={{
                                    marginBottom: "5px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "16px",
                                }}>
                                    {/* Left-side title */}
                                    <div style={{ marginLeft: "7px", fontSize: "14px" }}>
                                        Plant MIS
                                        &nbsp;&nbsp;
                                        <span style={{ marginLeft: "1rem" }}><select
                                            id="entries"
                                            value={itemsPerPage}
                                            onChange={(e) => {
                                                setItemsPerPage(Number(e.target.value));

                                            }}
                                        >
                                            <option value={12}>12</option>
                                            <option value={15}>15</option>
                                            <option value={20}>20</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={logData.length}>All</option> {/* Show all */}
                                        </select></span>


                                        <span style={{ marginLeft: '8px' }}>entries</span>
                                    </div>

                                    {/* Right-side date pickers */}
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}>

                                        <input
                                            type="text"
                                            className="form-control form-control-sm me-2"
                                            placeholder="Search..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            style={{
                                                padding: "1px 5px",
                                                borderRadius: "14px",
                                                border: "1px solid #ccc",
                                            }}
                                        />

                                        &nbsp;
                                        <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>

                                            <input
                                                type="date"
                                                value={endDate.replace(" ", "T")}
                                                onChange={(e) => handleEndDateChange(e.target.value)}
                                                style={{
                                                    padding: "6px 8px",
                                                    borderRadius: "14px",
                                                    border: "1px solid #ccc",
                                                }}
                                            />
                                        </label>

                                        <button onClick={fetchLogData} style={buttonStyle}>
                                            Show
                                        </button>
                                        <button onClick={exportToExcel} style={exportButtonStyle}>
                                            Excel
                                        </button>
                                        <button onClick={exportToPDF} style={exportButtonStyle2}>
                                            PDF
                                        </button>



                                    </div>
                                </div>

                                <div style={{ padding: "10px" }}>
                                    {/* Table */}
                                    <div className="table-responsive">
                                        <table className="table table-hover table-bordered">
                                            <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                                <tr>
                                                    <th style={tableHeading}> Sn.</th>
                                                    <th style={tableHeading}>User Name</th>
                                                    <th style={tableHeading}>Plant Name</th>
                                                    <th style={tableHeading}>Total Capacity [KWP]</th>
                                                    <th style={tableHeading}>Total Inverters</th>
                                                    <th style={tableHeading}> Date </th>
                                                    <th style={tableHeading}> Live Inverters</th>
                                                    <th style={tableHeading}> Offline Inverters</th>
                                                    <th style={tableHeading}> Total Generation [KWH]</th>
                                                    <th style={tableHeading}> Last Day Generation [KWH]</th>
                                                    <th style={tableHeading}> Today Generation [KWH]</th>
                                                    <th style={tableHeading}> Last Day CUF</th>
                                                    <th style={tableHeading}> Today CUF</th>
                                                    <th style={tableHeading}> Last Day Solar Insolation </th>
                                                    <th style={tableHeading}> Today Solar Insolation</th>
                                                    <th style={tableHeading}> Last Day PR</th>
                                                    <th style={tableHeading}>Today PR</th>






                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={tableHeaders.length} className="text-center">
                                                            Loading...
                                                        </td>
                                                    </tr>
                                                ) : currentData.length > 0 ? (
                                                    currentData.map((item, rowIndex) => (
                                                        <tr key={rowIndex}>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.SN ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.USER_NAME ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.PLANT_NAME ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Total_CAPACITY_KWP ?? ""}
                                                            </td>
                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Total_INVERTERS ?? ""}
                                                            </td>
                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.DATE ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Live_INVERTERS ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Offline_INVERTERS ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Total_GENERATION_KWH ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Last_Day_GENERATION_KWH ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Today_GENERATION_KWH ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Last_Day_CUF ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Today_CUF ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Last_Day_Solar_Insolation ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Today_Solar_Insolation ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.Last_Day_PR ?? ""}
                                                            </td>

                                                            <td className="text-center align-middle" style={tableBody}>
                                                                {item.TODay_PR ?? ""}
                                                            </td>




                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={tableHeaders.length} className="text-center">
                                                            No data available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination */}
                                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            style={paginationButtonStyle}
                                        >
                                            Previous
                                        </button>

                                        {[...Array(totalPages)].map((_, index) => {
                                            const isActive = currentPage === index + 1;
                                            return (
                                                <button
                                                    key={index}
                                                    onClick={() => handlePageChange(index + 1)}
                                                    style={{
                                                        ...paginationButtonStyle,
                                                        backgroundColor: isActive ? "#356E35" : "white",
                                                        color: isActive ? "#fff" : "#356E35",
                                                    }}
                                                >
                                                    {index + 1}
                                                </button>
                                            );
                                        })}

                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            style={paginationButtonStyle}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Stack>


                    </Stack>


                </Grid>

            </Grid>


            {/* <InvoicePage/> */}


        </>
    );
}

/* Styles */

const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    border: "1px solid lightgray",
    padding: "3px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
    display: "flex",
    flexWrap: "wrap"
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "2px 2px",
    borderRadius: "14px",
    border: "1px solid #ccc",
    // marginLeft: "5px",
    // fontSize: "10px",
};

const buttonStyle = {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "4px 9px",
    cursor: "pointer",
    fontSize: "13px",
};

const exportButtonStyle = {
    backgroundColor: "darkblue",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "4px 9px",
    cursor: "pointer",
    fontSize: "13px",
};

const exportButtonStyle2 = {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "4px 9px",
    cursor: "pointer",
    fontSize: "13px",
};

const paginationButtonStyle = {
    backgroundColor: "white",
    color: "#356E35",
    border: "1px solid #ddd",
    padding: "5px 10px",
    borderRadius: "5px",
    margin: "0 5px",
    cursor: "pointer",
    fontSize: "14px",
};

const tableHeading = {
    color: "rgb(53, 110, 53)",
    padding: "12px 10px",
    fontSize: "14px",
    whiteSpace: "nowrap",
}

const tableBody = {
    padding: "5px",
    whiteSpace: "nowrap",
}